import React from 'react';
export const Header = props => {
    const { headerTitle } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "header" },
            React.createElement("div", { className: "banner" },
                React.createElement("div", { className: "row" },
                    React.createElement("h1", null, headerTitle))))));
};
